




























import { mapActions, mapGetters } from "vuex";
import { General, App } from "@/utils/constants";
import MessageHeaderContent from "@/components/MessageHeaderContent.vue";
import { TemplateRef } from "@/components/types/template";

export default {
  name: "MessageHeader",
  components: {
    MessageHeaderContent
  },
  data() {
    return {
      General,
      App
    };
  },
  computed: {
    ...mapGetters({
      getUnreadMessageCount: "getUnreadMessageCount",
      isContrast: "isContrast",
      isMobile: "isMobile"
    })
  },
  watch: {
    isMobile(value) {
      if (value && (this.$refs.messageDropdown as TemplateRef).isActive)
        (this.$refs.messageDropdown as TemplateRef).toggle();
    }
  },
  async beforeMount() {
    await this.requestUnreadMessagesCount();
  },
  methods: {
    ...mapActions({
      requestUnreadMessagesCount: "requestUnreadMessagesCount",
      listMessages: "listMessages"
    })
  }
};
